import React,{useContext} from "react";
import style from "../../../styles/mystyle.module.css";
import { useTranslation } from "next-i18next";
import RemoveRedEyeRounded from "@mui/icons-material/RemoveRedEyeRounded";
import { grey } from "@mui/material/colors";
import Link from "@mui/icons-material/Link";
import Twitter from "@mui/icons-material/Twitter";
import Telegram from "@mui/icons-material/Telegram";
import LinkedIn from "@mui/icons-material/LinkedIn";
import Facebook from "@mui/icons-material/Facebook";
import IconButton from "@mui/material/IconButton";
import * as config from "../../../next.config.js";
import { styled } from "@mui/material/styles";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import {
  getCookieValue,
} from "../../helpers/helpers";
import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from "@mui/material/OutlinedInput";
import SendIcon from "@mui/icons-material/Send";
import FormControl from "@mui/material/FormControl";
import axios from "axios";
import { constants } from "../../../constants";
import Dialogs from "../../components/Dialogs/AlertDialog";
import { useRouter } from "next/router";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
} from "next-share";
import SeeMore from '../SeeMore'
import TermsContext from "../../../context/Trems"
import {getImage} from '../../helpers/images'
import {getTermsByVocabCodes} from '../../helpers/global/term/term'
import {CustomeFormControl ,  ListItem} from './Blog.style'
// const CustomeFormControl = styled(FormControl)(({ theme, locale }) => ({
//   width: "100%",
//   margin: 0,
//   '& label.Mui-focused': {
//     color: "#008C8D ",
//   },

//   '& .MuiSelect-icon': {
//     color: "#008C8D "
//   },
//   '& .MuiInputLabel-root': {

//     fontSize: "1rem !important",

//   },
//   '@media only screen and  (min-width:280px){': {
//     '& .MuiInputLabel-root': {

//       fontSize: "1rem !important",

//     },
//   },
//   '@media (min-width:768px) and (max-width:912px)': {
//     '& .MuiInputLabel-root': {

//       fontSize: "1.2rem !important",

//     },
//     width: "100%",
//   },
//   '@media (min-width:913px) ': {
//     '& .MuiInputLabel-root': {

//       fontSize: "1.2rem !important",

//     },
//     width: "100%",
//   },

// }));
// const ListItem = styled("li")(({ theme }) => ({ margin: theme.spacing(0.5) }));



function Post({ blogId, image,blogDetailsData }) {
  const [Images, setImages] = React.useState([]);
  const [comments, setComments] = React.useState([]);
  const [Open, setOpen] = React.useState(false);
  const [Text, setText] = React.useState("");
  const router = useRouter();
  const vocabTerms= useContext(TermsContext)
  const { locale } = useRouter();
  const [blogEntityDetails, setBlogEntityDetails] = React.useState([]);
  const [blogDetails, setBlogDetails] = React.useState(blogDetailsData);
  const [Tags, setTags] = React.useState([]);
  const [Value, setValue] = React.useState("");
  const [ViewsTotal, setViewsTotal] = React.useState("");
  const [showSeeMore, setShowSeeMore] = React.useState(false);
  const [limit, setLimit] = React.useState(10);
  const [pageId, setPageId] = React.useState(0);
  const [loading, setloading] = React.useState(true);
  let status;

  const handleChange = event => {
    event.persist();
    setValue(event.target.value);
  };
  const handleSubmit = e => {
    let data2 = {
      blog: parseInt(blogId),
      body: Value
    };

    axios
      .post(`${config["basePath"]}/api/cms/blog/comments/add`, {
        data: [data2],
        method: "POST"
      })
      .then(res => {
   
        if (res.status == 200 && res.data.data) {
      
     let statusId =res.data.data && res.data.data.statusId
                  let commentStatus = vocabTerms.status.filter(
                    s => s.id== statusId
                  );
                
                  if (commentStatus.length>0) {
                    setOpen(true);

                    let message =
                      commentStatus &&
                      commentStatus.filter(c => c.language.code == locale)
                        .length > 0
                        ? commentStatus &&
                          commentStatus.filter(
                            c => c.language.code == locale
                          )[0].name
                        : commentStatus[0].name;
                    setText(message);
                  }
           
        }
      })
      .catch(err => (err));
  };
  const getcomments = (blogId, pageNumber) => {

        let statusId = vocabTerms.statusIds;
        setPageId(pageNumber);
        axios
          .get(`${config["basePath"]}/api/cms/blog/comments/details`, {
            params: {
              statusId: JSON.stringify(statusId),
              id: JSON.stringify([parseInt(blogId)]),
              limit: limit,
              pageId: pageNumber
            }
          })
          .then(comments => {
         
            setloading(false);
        
            if (comments.data.data.length > 0) {
              if (pageNumber > 1) {
                setComments(prev => [...prev, ...comments.data.data]);
              } else {
                setComments([...comments.data.data]);
              }
            }
         
            if (limit == comments.data.pageable.numberOfElements) {
              if (limit * pageId < comments.data.pageable.totalElements) {
                setShowSeeMore(true);
              }
            } else {
              setShowSeeMore(false);
            }
          })
          .catch(err => err);
    
  };
  const getData = blogId => {
    let tmepblogFiles =[]
    setImages([]);
        status = vocabTerms.statusIds;
     
        
            // let tempLstBlogs = [...blogDetails]
            if (blogId!=null) {
            

               axios
                .get(`${config["basePath"]}/api/cms/blog/getFiles`, {
                  params: {
                    blogId: JSON.stringify([blogId])
                  }
                })
                .then(async blogFiles => {
                   tmepblogFiles = blogFiles.data.data.data;
               
                  if (tmepblogFiles.length > 0 && tmepblogFiles.filter(i=>i.blogId==blogId).length>0 ) {
                    if (
                      tmepblogFiles.filter(i=>i.blogId==blogId)[0].blogFiles.filter(i => i.files != null)
                        .length > 0
                    ) {
                      let img=await getImage(  tmepblogFiles.filter(i=>i.blogId==blogId)[0].blogFiles.filter(
                        i => i.files != null
                      )[0].files.fileId,  tmepblogFiles.filter(i=>i.blogId==blogId)[0].blogFiles.filter(
                                i => i.files != null
                              )[0].files.filePath)
                    
                          let resImage = [
                            {
                              image: img,
                              blogId:tmepblogFiles.filter(i=>i.blogId==blogId)[0].blogId
                            }
                          ];
                    
                          image({image:
                            tmepblogFiles.filter(i=>i.blogId==blogId)[0].blogFiles.filter(
                              i => i.files != null
                            ).length>0?
                            tmepblogFiles.filter(i=>i.blogId==blogId)[0].blogFiles.filter(
                              i => i.files != null
                            )[0].files.filePath:"" ,
                             body:blogDetailsData[0] && blogDetailsData[0].transBlog[0].body.replace(/<([^>]+)>|\&nbsp;/ig,'').substr(0, 150)
      
                          }
                          );
                    
                          setImages(resImage);
                    }
                  }
                })
                .catch(err => err);
            
          
              axios.post(`${config["basePath"]}/${constants.ENTITY_DETAILS_URL}`, {
                  data: {
                    lang: locale,
                    statusId: JSON.stringify(status),
                    id: JSON.stringify(
                      Array.from(
                        new Set(blogDetailsData.map(item => item.entityDetailsId))
                      )
                    )
                  }
                })
                .then(async entities => {
                  if (entities.data.data.data) {
                    let tempData = entities.data.data.data;
                    if (tempData.length) {
                      let ImageType = ["logo"];
                      await axios
                        .get(
                          `${config["basePath"]}/api/registeration/entityImages/get`,
                          {
                            params: {
                              entityId: JSON.stringify(
                                blogDetailsData.map(i => i.id)
                              ),
                              statusId: JSON.stringify(status),
                              //   entityImageType: JSON.stringify(ImageType),
                              limit: constants.limitOfEntityImages
                            },
                            headers: {
                              "Content-Type": "application/json",
                              "accept-language": locale
                            }
                          }
                        )
                        .then(respEntityImages => {
                          if (respEntityImages.data.data.data.length > 0) {
                            tempData.map(i => {
                              i.images = respEntityImages.data.data.data;

                              return i;
                            });
                            //   )
                          }

                          setBlogEntityDetails([
                            ...tempData.filter(
                              itm => itm.id == blogDetailsData[0].entityDetailsId
                            )
                          ]);
                        })
                        .catch(err => (err));
                    }
                  }
                })
                .catch(err => err);

              axios
                .get(`${config["basePath"]}/api/cms/blog/tags/blogtags`, {
                  params: {
                    statusId: JSON.stringify(status),
                    id: JSON.stringify(blogId)
                  }
                })
                .then(blogtags => {
                  // console.log("blogTags====>",blogtags)
                  if (blogtags.data.data.length > 0) {
                    setTags(blogtags.data.data);
                  }
                })
                .catch(err => err);

                getTermsByVocabCodes(["statistic-entities","view-types"]).then(termRes=>{

           
                  let type =
                  blogDetailsData[0].blogTypes[0].code == "news"
                      ? "news"
                      : "blog";
                  let statisticEntity =
                  JSON.parse(termRes).length > 0 &&
                  JSON.parse(termRes).filter(ele=>ele.vocCode=="statistic-entities").filter(i => i.code == type).length > 0
                      ?JSON.parse(termRes).filter(ele=>ele.vocCode=="statistic-entities").filter(i => i.code == type)[0].id
                      : "";
                 
                      let viewType =
                        JSON.parse(termRes).filter(ele=>ele.vocCode=="view-types").length > 0 &&
                        JSON.parse(termRes).filter(ele=>ele.vocCode=="view-types").filter(i => i.code == "free").length >
                          0
                          ? JSON.parse(termRes).filter(i => i.code == "free")[0].id
                          : null;
                      axios
                        .get(
                          `${config["basePath"]}/api/statistics/Views/getViews`,
                          {
                            params: {
                              entityId: blogId,
                              statisticEntityClassTypeId: statisticEntity,
                              viewTypeId: viewType
                            }
                          }
                        )
                        .then(res => {
                          if (res.data.data.length > 0) {
                            setViewsTotal(res.data.data[0].viewCount);
                          }
                        })
                        .catch(err => err);
                      })
            }
 
  };

  React.useEffect(() => {
    setBlogEntityDetails([]);
    setBlogDetails(blogDetailsData);
    setImages([]);
    setComments([]);
    setViewsTotal("");
    setTags([]);
    getData(blogId);
    getcomments(blogId, 1);
  }, [blogId]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleSearch = (tag, blogType) => {
    let data = {};
    data.tag = tag.blogTagsId;
    router.push({
      pathname: "/" + constants.blogsLink + "/" + blogType,
      query: data
    });
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const { t } = useTranslation("common");

  return (
    <div className={style.SectionContainer + " "}>
      <div className={style.allcard}>
        <Dialogs
          open={Open}
          text={Text}
          type={"success"}
          btnOk={() => {
            setOpen(false);
            setValue("");
          }}
        />
        { blogDetails  && blogDetails.length ?
          blogDetails.map(item => {
            return (
              <div className={style.stylesSection7}>
                <div className={style.twoimg}>
                  {/* <div className={style.profile}> */}
                    <div className={style.Detailprofile}>
                      <div className={style.profile1}>
                        <img
                          className={style.profileimg}
                          src={
                            blogEntityDetails &&
                            blogEntityDetails.length > 0 &&
                            blogEntityDetails[0].images &&
                            blogEntityDetails[0].images.length > 0
                              ? blogEntityDetails[0].images[0].files.filePath
                              : `${config.basePath}/assest/globe.svg`
                          }
                        />
                      </div>
                      <div className={style.profile2}>
                        <p className={style.doctorName}>
                          {blogEntityDetails.length
                            ? blogEntityDetails[0].transEntityDetails[0]
                                .officialName
                            : ""}
                        </p>
                      </div>
                      <div className={style.profile3}>
                        <p className={style.doctorName}>
                          <span>
                            {new Date(item.createdOn).toDateString()}{" "}
                          </span>
                          {/* {blogEntityDetails.length ? blogEntityDetails[0].entityType.filter(itm => itm.language.code == locale)[0].name : ""}    */}
                          {/* {t("DateandTime")}    */}
                        </p>
                      </div>
                    </div>
                  {/* </div> */}
                  <div className={style.profile}>
                    {/* <IconButton
                      aria-label="more"
                      id="long-button"
                      aria-controls={open ? "long-menu" : undefined}
                      aria-expanded={open ? "true" : undefined}
                      aria-haspopup="true"
                      onClick={handleClick}
                      style={{ width: "2.5rem", color: " #F52A59" }}
                    >
                      <MoreVertIcon /> */}
                    {/* </IconButton>
                    <Menu
                      id="long-menu"
                      MenuListProps={{
                        "aria-labelledby": "long-button"
                      }}
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      PaperProps={{
                        style: {
                          maxHeight: ITEM_HEIGHT * 4.5,
                          width: "20ch"
                        }
                      }}
                    >
                      {option.map(option => (
                        <MenuItem
                          key={option}
                          selected={option === "Add"}
                          onClick={handleClose}
                        >
                          {option}
                        </MenuItem>
                      ))}
                    </Menu> */}
                  </div>
                </div>
                <h1 className={style.ArticalTitle}>
                  {" "}
                  {item.transBlog[0].title}{" "}
                </h1>
                <div className={style.cardspost}>
                  <div className={style.card}>
                  {/* {Images&&
                    Images.length > 0 &&
                    Images.filter(i => i.blogId == item.id).length > 0 ? (
                      <img
                        className={style.imgpost}
                        src={Images.filter(i => i.blogId == item.id)[0].image}
                      ></img>
                    ) : (
                      <img
                        className={style.imgpost}
                        src={`${config.basePath}/assest/defaultBlogImage.svg`}
                      ></img>
                    )} */}

<img
                        className={style.imgpost}
                        src={  Images&&   Images.length > 0 && Images.filter(i => i.blogId == item.id).length>0&&Images.filter(i => i.blogId == item.id)[0].image !=null?Images.filter(i => i.blogId == item.id)[0].image  :`${config.basePath}/assest/defaultBlogImage.svg`}
                      ></img>
                      <div   className={style.detailpost}>
                    <div
                    
                      dangerouslySetInnerHTML={{
                        __html: item.transBlog[0].body
                      }}
                    ></div>
                    </div>
                  </div>
                  {Tags && Tags.length > 0 ? (
                    <p className={style.tagWord}>{t("Tag")}</p>
                  ) : (
                    " "
                  )}
                  <div className={style.card}>
                    <Paper
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        boxShadow: "none",
                        margin: "auto",
                        flexWrap: "wrap",
                        listStyle: "none",
                        padding: "10px",
                        p: 0.5,
                        m: 0
                      }}
                      component="ul"
                    >
                      {Tags.map(data => {
                        let icon;
                        //  icon = <TagFacesIcon />

                        return (
                          <ListItem key={data.id}>
                            <Chip
                              icon={icon}
                              label={data.name}
                              onClick={() =>
                                handleSearch(
                                  data,
                                  blogDetails &&
                                    blogDetails[0].blogTypes[0].code
                                )
                              }

                              // onDelete={data.name == 'React' ? undefined : handleDelete(data)}
                            />
                          </ListItem>
                        );
                      })}
                    </Paper>
                  </div>
                </div>

                <hr
                  style={{
                    color: "black",
                    width: "98%",
                    height: "2px",
                    borderWidth: "1px",
                    margin: "auto",
                    align: "center",
                    color: "grey"
                  }}
                />
                <div className={style.card}>
                  <div className={style.cardssocail}>
                    <div className={style.card}>
                      <LinkedinShareButton
                        url={String(config.env.baseUrl + router.asPath)}
                        quote={item.transBlog[0].body.substr(0, 100)}
                      >
                        <LinkedIn sx={{ color: grey[500] }} />
                      </LinkedinShareButton>
                    </div>

                    <div className={style.card}>
                      <FacebookShareButton
                        url={String(config.env.baseUrl + router.asPath)}
                        quote={item.transBlog[0].body.substr(0, 100)}
                      >
                        <Facebook sx={{ color: grey[500] }} />
                      </FacebookShareButton>
                    </div>
                    <div className={style.card}>
                      <TelegramShareButton
                        url={String(config.env.baseUrl + router.asPath)}
                        quote={item.transBlog[0].body.substr(0, 100)}
                      >
                        <Telegram sx={{ color: grey[500] }} />
                      </TelegramShareButton>
                    </div>

                    <div className={style.card}>
                      <TwitterShareButton
                        url={String(config.env.baseUrl + router.asPath)}
                        quote={item.transBlog[0].body.substr(0, 100)}
                      >
                        <Twitter sx={{ color: grey[500] }} />
                      </TwitterShareButton>
                    </div>
                    <div className={style.card}>
                      <Link
                        href={config.env.baseUrl + router.asPath}
                        sx={{ color: grey[500] }}
                      />
                    </div>
                  </div>
                </div>
                <hr
                  style={{
                    color: "black",
                    width: "98%",
                    height: "2px",
                    borderWidth: "1px",
                    margin: "auto",
                    align: "center",
                    color: "grey"
                  }}
                />
                <br />
                <div className={style.card}>
                  <div className={style.Commentstyle}>
                    <div className={style.comment}>
                      <div className={style.profile}>
                        {comments && comments.length > 0 ? (
                          <div className={style.Detailcommentright}>
                            <div className={style.profile1}>
                              <p className={style.Commenttitle}>
                              {t("comment")}
                              </p>
                            </div>
                            <div className={style.profile3}>
                              <p className={style.Commenttitle}>
                                {comments.length}
                              </p>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className={style.profile}>
                        <div className={style.Detailcommentleft}>
                          {/* <div className={style.Detailcommentright}>
                            {/* <div className={style.profile3}>
                                                   <p className={style.Commenttitle}>100</p>
                                                </div> */}
                          {/* <div className={style.profile1}>
                                                   <Favorite sx={{ color: pink[500] }} />
                                                </div>
                                             </div>  */}
                          {ViewsTotal && ViewsTotal != null ? (
                            <div className={style.Detailcommentright}>
                              <div className={style.profile3}>
                                <p className={style.Commenttitle}>
                                  {ViewsTotal}
                                </p>
                              </div>
                              <div className={style.profile1}>
                                <RemoveRedEyeRounded
                                  sx={{ color: "#008C8D " }}
                                />
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {comments && comments.length > 0
                    ? comments.map(i => {
                        return (
                          <div className={style.Commentstyle}>
                            <div>
                              <div className={style.profile}>
                                <div className={style.Detailcommentright}>
                                  <div className={style.profile1}>
                                    <p
                                      className={
                                        style.Commenttitle +
                                        " " +
                                        style.textalign
                                      }
                                    >
                                      {i.body}
                                    </p>
                                  </div>
                               
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    : ""}
                      {comments.length > 0 && showSeeMore ? (
                                 
                                 <SeeMore
                                   getMore={event => {
                                     setloading(true);
                                     let tempPageId = pageId + 1;

                                     getcomments(blogId, tempPageId);
                                   }}
                                   loading={loading}
                                   text={t("SeeMore")}
                                 />
                               ) : (
                                 ""
                               )}
                  {getCookieValue("login") &&
                  getCookieValue("login").Authorization &&
                  blogDetails &&
                  blogDetails[0].enableComment == true ? (
                    <div className={style.Commentstyle}>
                      <div className={style.profile}>
                        <div className={style.profile1}>
                          <CustomeFormControl>
                            <OutlinedInput
                              id="WriteComment"
                              placeholder={t("WriteComment")}
                              multiline
                              rows={1}
                              name="WriteComment"
                              size="medium"
                              onChange={handleChange}
                              value={Value}
                              label={t("WriteComment")}
                              endAdornment={
                                <InputAdornment position="start">
                                  <IconButton
                                    onClick={() => handleSubmit()}
                                    disabled={!Value}
                                  >
                                    {" "}
                                    <SendIcon style={{ width: "1.5rem" }} />
                                  </IconButton>
                                </InputAdornment>
                              }
                            ></OutlinedInput>
                          </CustomeFormControl>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            );
          }):""}
      </div>
    </div>
  );
}

export default Post;
